import type { SidePanel } from '../types';

export const Tickets: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./TicketsPanel.vue')),
};
